var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPuddle = function SvgPuddle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 220 63"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#puddle_svg__a)",
    fillRule: "evenodd",
    d: "M184.95 35.928c20.108-3.765 32.581-9.008 32.581-14.806 0-11.458-48.702-20.747-108.779-20.747S-.028 9.664-.028 21.122c0 9.674 34.715 17.801 81.681 20.098l-.005.003h.084l1.392.067c1.634.165 2.276.66-.633 1.733l-.148.054-.019.007c-5.073 1.863-7.934 3.975-7.934 6.211 0 7.55 32.596 13.67 72.805 13.67s72.804-6.12 72.804-13.67c0-4.985-14.213-9.346-35.446-11.734-3.617-.705-1.481-1.191-.103-1.505.191-.044.368-.084.513-.121z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "puddle_svg__a",
    x1: 54.632,
    x2: 209.085,
    y1: 44.529,
    y2: 14.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })))));
};
export default SvgPuddle;